//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FeatureContainer from '~/components/forCompanies/FeatureContainer.vue'
import DescriptionCard from '~/components/forGaming/DescriptionCard.vue'
import TopScreen from '~/components/TopScreen.vue'
import FooterTop from '~/components/footer/footerTop.vue'
export default {
  components: {
    TopScreen,
    FeatureContainer,
    DescriptionCard,
    FooterTop
  },
  head () {
    return {
      title: this.$t('footer.solutions.recurring').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  }
}
